export default __webpack_public_path__ + "static/media/happets2.21798738.png";